export default "__VITE_ASSET__DHPR_1Zu__"